import { subscribe } from './realtime.js';

function enhance(root) {
    if (root.dataset.realtimeProgressEnhanced === 'true') return;
    const topic = root.dataset.realtimeOperationTopic;
    if (!topic) return;
    root.dataset.realtimeProgressEnhanced = 'true';
    const progress = root.querySelector('[role="progressbar"]');
    const bar = progress?.querySelector('.progress-bar') || progress;
    const status = root.querySelector('[data-realtime-operation-status]');
    subscribe(topic, (type, detail) => {
        if (type !== 'operation-progress') return;
        if (status) status.textContent = globalThis.UnionStackI18n.label(detail.state);
        if (bar && Number.isFinite(detail.percent)) {
            progress?.setAttribute('aria-valuenow', String(detail.percent));
            bar.style.width = `${detail.percent}%`;
            if (bar.dataset.realtimeShowPercent === 'true') bar.textContent = `${detail.percent}%`;
        }
        root.dataset.operationState = detail.state;
        if (root.dataset.realtimeOperationReloadOnTerminal === 'true'
            && ['completed', 'completed-with-errors', 'completed-with-warnings', 'cancelled', 'failed'].includes(detail.state)) {
            window.location.reload();
        }
    });
}

function enhanceAll(root = document) {
    if (root instanceof Element && root.matches('[data-realtime-operation-topic]')) enhance(root);
    root.querySelectorAll('[data-realtime-operation-topic]').forEach(enhance);
}

if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => enhanceAll(), { once: true });
else enhanceAll();

export { enhance as enhanceRealtimeProgress, enhanceAll as enhanceRealtimeProgressSurfaces };
